import axios from 'axios';
import { API_BASE_URL } from './config';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL, // Set your API base URL
});

const logout = () => {
  localStorage.removeItem('homeshiksha-jwt');
  window.location.href = '/';
};

axiosInstance.interceptors.request.use(
  config => {
    const token = JSON.parse(localStorage.getItem('homeshiksha-jwt')); // Retrieve your JWT token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
